var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidFieldCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.974854,
    width: 31.01,
    height: 31.01,
    rx: 15.505,
    fill: "#E1EBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3186 11.6531C22.7786 11.9789 22.8538 12.5737 22.4865 12.9817L15.1276 21.1577C14.9303 21.3769 14.6334 21.5071 14.3172 21.513C14.001 21.5189 13.6982 21.4 13.4906 21.1883L9.55223 17.1728C9.1659 16.7789 9.21272 16.1818 9.65681 15.8391C10.1009 15.4965 10.7741 15.538 11.1604 15.9319L14.2595 19.0917L20.8207 11.8021C21.188 11.3941 21.8586 11.3274 22.3186 11.6531Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidFieldCheckmark);
export default __webpack_public_path__ + "static/media/valid-field-checkmark.89a57e88cb718e4e680d9ca44cd2e083.svg";
export { ForwardRef as ReactComponent };